import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { ShippingMethodType } from 'Type/Checkout.type';
import { TotalsType } from 'Type/MiniCart.type';
import { getCartShippingItemPrice } from 'Util/Cart';
import { formatPrice } from 'Util/Price';

import DeliveryOption from './DeliveryOption.component';

/** @namespace PeggysagePwa/Component/DeliveryOption/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    getCartShippingItemPrice: getCartShippingItemPrice(state),
    totals: state.CartReducer.cartTotals,
    defaultCountry: state.ConfigReducer.default_country
});

/** @namespace PeggysagePwa/Component/DeliveryOption/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace PeggysagePwa/Component/DeliveryOption/Container */
export class DeliveryOptionContainer extends PureComponent {
    static propTypes = {
        option: ShippingMethodType.isRequired,
        currency: PropTypes.string,
        totals: TotalsType.isRequired,
        getCartShippingItemPrice: PropTypes.func.isRequired,
        defaultCountry: PropTypes.string
    };

    static defaultProps = {
        currency: null,
        defaultCountry: 'FR'
    };

    containerFunctions = {
        getOptionPrice: this.getOptionPrice.bind(this)
    };

    containerProps() {
        const {
            option = {},
            defaultCountry
        } = this.props;

        return {
            option,
            defaultCountry
        };
    }

    getOptionPrice() {
        const {
            option = {},
            currency,
            getCartShippingItemPrice,
            totals: {
                prices: {
                    quote_currency_code: quoteCurrency = 'EUR'
                } = {}
            }
        } = this.props;

        return formatPrice(getCartShippingItemPrice(option), currency || quoteCurrency);
    }

    render() {
        return (
            <DeliveryOption
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryOptionContainer);
